import PasswordTooltipWrapper from 'Common/PasswordTooltipWrapper/PasswordTooltipWrapper'
import FloatingAuthInput from 'NewComponents/FormComponents/FloatingAuthInput/FloatingAuthInput';
import Button from 'Pages/LoginPage/Button';
import React, { useState } from 'react'
import { useSearchParams } from 'react-router-dom';
import encryption from 'Utils/encryptionPassword';

const CreatePasswordForm = ({ handleReset, loading }) => {

    const [error, setError] = useState("");

    const [password, setPassword] = useState({
        newPassword: "",
        confirmPassword: "",
    });

    const [searchParams] = useSearchParams();




    const onHandleChange = (e) => {
        const { name, value } = e.target;
        setPassword((prevPassword) => ({
            ...prevPassword,
            [name]: value,
        }));
        setError("");
    };

    const handleResetPass = () => {
        const key = searchParams.get("trucarekey");
        const emailTo = searchParams.get("emailTo");
        if (password.newPassword === "") {
            setError("Password is required");
            return;
        }
        if (password.newPassword !== password.confirmPassword) {
            setError("Passwords do not match");
            return;
        }
        let encryptPassword = encryption(password.newPassword);

        handleReset(key, emailTo, encryptPassword)
    }

    const handleEnter = (e) => {
        if (e.charCode === 13) {
            handleResetPass();
        }
    };

    return (
        <div className="flex flex-col justify-center gap-6">
            <div>
                <PasswordTooltipWrapper value={password.newPassword}  >
                    <FloatingAuthInput
                        id="newPassword"
                        label="New Password"
                        type="password"
                        placeholder="••••••••"
                        required
                        name="newPassword"
                        autoComplete="new-password" onKeyPress={handleEnter} value={password.newPassword}
                        onChange={onHandleChange}

                    />
                </PasswordTooltipWrapper>
            </div>

            <div>

                <FloatingAuthInput
                    id="confirmPassword"
                    label="Confirm Password"
                    type="password"
                    placeholder="••••••••"
                    required
                    name="confirmPassword"
                    autoComplete="new-password" onKeyPress={handleEnter} value={password.confirmPassword}
                    onChange={onHandleChange}

                />
                {error ? <p className='font-semibold rounded-sm text-rose-400 '>{error}</p> : ""}
            </div>

            <Button loading={loading} onClick={handleResetPass} variant="primary" fullWidth>
                Create Password
            </Button>



        </div>
    )
}

export default CreatePasswordForm